import clsx from 'clsx';
import React from 'react';

import { PaginationType } from '@utils/backend-api/subscriber_directory';

import styles from './styles.module.scss';

interface PaginationProps {
  getPath: (page: number) => string;
  paginationData: PaginationType;
  setPage?: (page: number) => void;
}

export default function Pagination({ setPage, paginationData, getPath }: PaginationProps) {
  const { page, totalPages, hasNextPage, nextPage } = paginationData;
  const nextPages = [...Array(3)];
  const prevPages = [...Array(3)];
  return (
    <ul className={styles.pagination} data-test="pagination">
      {totalPages >= page && page > 1 && (
        <li className={styles.pageItem}>
          <a
            href={getPath(1)}
            className={styles.pageLink}
            onClick={(e) => {
              if (typeof setPage !== 'undefined') {
                e.preventDefault();
                setPage(1);
              }
            }}
          >
            &laquo; First
          </a>
        </li>
      )}
      {page > 1 && (
        <li className={styles.pageItem}>
          <a
            href={getPath(page - 1)}
            className={styles.pageLink}
            onClick={(e) => {
              if (typeof setPage !== 'undefined') {
                e.preventDefault();
                setPage(page - 1);
              }
            }}
          >
            &lsaquo;&nbsp;Prev
          </a>
        </li>
      )}
      {[...prevPages, ...nextPages].map((_, i) => {
        const index = i + 1;

        if (totalPages < index) return null;

        if (index === page)
          return (
            <li key={i} className={clsx(styles.pageItem, styles.currentPage, styles.pageLink)}>
              {page}
            </li>
          );

        return (
          <li className={styles.pageItem} key={i}>
            <a
              href={getPath(index)}
              className={styles.pageLink}
              onClick={(e) => {
                if (typeof setPage !== 'undefined') {
                  e.preventDefault();
                  setPage(index);
                }
              }}
            >
              {index}
            </a>
          </li>
        );
      })}
      {hasNextPage && (
        <li className={styles.pageItem}>
          <a
            href={getPath(nextPage)}
            className={styles.pageLink}
            data-test="pagination-next"
            onClick={(e) => {
              if (typeof setPage !== 'undefined') {
                e.preventDefault();
                setPage(nextPage);
              }
            }}
          >
            Next&nbsp;&rsaquo;
          </a>
        </li>
      )}
    </ul>
  );
}
